import { useEffect } from 'react';

import { H1, Text } from '@betterment/samba-react';

import { urlBuilder } from '~/b4b/utils/urlBuilder';

import { ErrorContent } from '../error-content/ErrorContent';
import { SambaAutoLink } from '../SambaAutoLink';

const FullPageErrorFallback = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <ErrorContent>
      <ErrorContent.Image />
      <ErrorContent.Header>
        <H1>Unable to complete request</H1>
      </ErrorContent.Header>
      <ErrorContent.Description>
        <Text>
          We're sorry, we're working to resolve this issue. Please try again later. If the issue continues,{' '}
          <SambaAutoLink to={urlBuilder.support()}>contact us</SambaAutoLink>.
        </Text>
      </ErrorContent.Description>
    </ErrorContent>
  );
};

export default FullPageErrorFallback;
